"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const formik_1 = require("formik");
const react_redux_1 = require("react-redux");
const yup = __importStar(require("yup"));
const selectors_1 = require("@/store/ducks/ports/selectors");
const selectors_2 = require("@/store/ducks/countries/selectors");
const ports_1 = require("@/store/ducks/ports");
const createPortsUseCase_1 = __importDefault(require("@/useCases/ports/createPortsUseCase"));
const index_view_1 = __importDefault(require("./index.view"));
function PortsTable() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const selectedCountryId = (0, react_redux_1.useSelector)(selectors_2.selectedCountryIdSelector);
    const ports = (0, react_redux_1.useSelector)(selectors_1.filteredPorts);
    const isSavePromptVisible = (0, react_redux_1.useSelector)(selectors_1.isSavePromptVisibleSelector);
    const isCreatingPort = (0, react_redux_1.useSelector)(selectors_1.isCreatingPortSelector);
    const initialValues = {
        ports: ports.map((port) => port.name),
    };
    yup.addMethod(yup.array, "uniqueArray", function (mapper = (port) => port, message = "") {
        return this.test("uniqueArray", message, function (list) {
            const uniqueValues = Array.from(new Set(list?.map(mapper)));
            const isUnique = list?.length === uniqueValues.length;
            if (isUnique) {
                return true;
            }
            const uniqueIndex = list?.findIndex((row, i) => row !== uniqueValues[i]);
            if (list &&
                uniqueIndex &&
                list[uniqueIndex] &&
                list[uniqueIndex] === "") {
                return true;
            }
            throw this.createError({
                path: `${this.path}[${uniqueIndex}]`,
                message,
            });
        });
    });
    const validatorSchema = yup.object().shape({
        ports: yup
            .array()
            .of(yup.string().required("Required"))
            .uniqueArray((value) => {
            return value;
        }, "This name should be unique"),
    });
    const onOpenSavePrompt = () => {
        if (!isSavePromptVisible) {
            dispatch((0, ports_1.onShowSavePrompt)());
        }
    };
    const onSubmit = async (values) => {
        const newPorts = values.ports.filter((port) => !initialValues.ports.includes(port));
        await (0, createPortsUseCase_1.default)(selectedCountryId, newPorts)(dispatch);
    };
    return (react_1.default.createElement(formik_1.Formik, { validationSchema: validatorSchema, onSubmit: onSubmit, initialValues: initialValues, validateOnChange: true, enableReinitialize: true, validateOnBlur: true }, (props) => {
        return (react_1.default.createElement(index_view_1.default, { isLoading: isCreatingPort, rows: props.values, isCountrySelected: Boolean(selectedCountryId), onOpenSavePrompt: onOpenSavePrompt }));
    }));
}
exports.default = PortsTable;
